<template>
	<v-sheet elevation="0" max-width="700px" class="mx-auto">
		<FunctionTitle :title="''" />
		<CommonFlame :title="'社員情報編集'">
			<div class="validate-error pa-2 pa-sm-4" v-if="errors.length">
				<v-row v-for="(error, i) in errors" :key="`errors-${i}`" no-gutters align="center">
					<v-col cols="1">
						<v-icon color="red" class="shrink"> mdi-alert-circle-outline </v-icon>
					</v-col>
					<v-col cols="11" class="pl-sm-0 pl-2">
						{{ error }}
					</v-col>
				</v-row>
			</div>
			<v-form ref="form" v-model="valid">
				<UserFormEmployeeNumber :employeeNumber.sync="user_info.employeeNumber" />
				<v-row no-gutters>
					<v-col sm="6" cols="12" class="p-auto-1">
						<UserFormLastName :lastName.sync="user.lastName" />
					</v-col>
					<v-col sm="6" cols="12" class="p-auto-1">
						<UserFormFirstName :firstName.sync="user.firstName" />
					</v-col>
					<v-col sm="6" cols="12" class="p-auto-1">
						<UserFormLastNameKana :lastNameKana.sync="user.lastNameKana" />
					</v-col>
					<v-col sm="6" cols="12" class="p-auto-1">
						<UserFormFirstNameKana :firstNameKana.sync="user.firstNameKana" />
					</v-col>
				</v-row>
				<UserFormPosition :position.sync="user.position" />
				<UserFormHireDate
					:year.sync="user_info.year"
					:month.sync="user_info.month"
					:day.sync="user_info.day"
				/>
				<v-select
					v-model="user.department_ids"
					:items="departments"
					label="所属部門"
					item-text="name"
					item-value="id"
					class="mt-4"
					multiple
					outlined
					dense
				/>
				<v-row no-gutters justify="center" class="my-4">
					<v-btn color="secondary" :disabled="!valid" @click.prevent="updateUser">
						<v-icon class="mr-2">mdi-pencil</v-icon>
						編集する</v-btn
					>
				</v-row>
			</v-form>
		</CommonFlame></v-sheet
	>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import UserFormLastName from "../../view/user/forms/UserFormLastName.vue"
import UserFormFirstName from "../../view/user/forms/UserFormFirstName.vue"
import UserFormLastNameKana from "../../view/user/forms/UserFormLastNameKana.vue"
import UserFormFirstNameKana from "../../view/user/forms/UserFormFirstNameKana.vue"
import UserFormHireDate from "../../view/user/forms/UserFormHireDate.vue"
import UserFormPosition from "./forms/UserFormPosition.vue"
import UserFormEmployeeNumber from "./forms/UserFormEmployeeNumber.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		UserFormLastName,
		UserFormFirstName,
		UserFormLastNameKana,
		UserFormFirstNameKana,
		UserFormHireDate,
		UserFormPosition,
		UserFormEmployeeNumber,
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			user: {
				id: this.$route.params["id"],
				firstName: "",
				lastName: "",
				firstNameKana: "",
				lastNameKana: "",
				position: "",
				department_ids: [],
			},
			user_info: {
				hireDate: "",
				year: "",
				month: "",
				day: "",
				employeeNumber: "",
			},
			departments: [],
			valid: false,
			errors: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchUser()
	},
	methods: {
		fetchUser() {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/users/${this.user.id}/edit`, {
					headers,
				})
				.then((res) => {
					this.user.id = res.data.user.id
					this.user.position = res.data.user.position
					this.user.firstName = res.data.user.first_name
					this.user.lastName = res.data.user.last_name
					this.user.firstNameKana = res.data.user.first_name_kana
					this.user.lastNameKana = res.data.user.last_name_kana
					this.user_info.hireDate = res.data.user_info.hire_date
					this.user_info.employeeNumber = res.data.user_info.employee_number
					this.user.department_ids = res.data.user.departments.map((d) => d.id)
					this.departments = res.data.departments
					if (this.user_info.hireDate) {
						this.separateHireDate()
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		separateHireDate() {
			this.user_info.year = this.user_info.hireDate.slice(0, 4)
			this.user_info.month = this.user_info.hireDate.slice(5, 7)
			this.user_info.day = this.user_info.hireDate.slice(8, 10)
		},
		setHireDate() {
			this.user_info.hireDate =
				this.user_info.year + "-" + this.user_info.month + "-" + this.user_info.day
		},
		updateUser() {
			this.setHireDate()
			const headers = authenticate.setHeader()

			axios
				.put(
					`/erp/v1/users/${this.user.id}`,
					{
						user_main: {
							user: {
								position: this.user.position,
								first_name: this.user.firstName,
								last_name: this.user.lastName,
								first_name_kana: this.user.firstNameKana,
								last_name_kana: this.user.lastNameKana,
								department_ids: this.user.department_ids,
							},
							user_info: {
								hire_date: this.user_info.hireDate,
								employee_number: this.user_info.employeeNumber,
							},
						},
					},
					{
						headers,
					}
				)
				.then((res) => {
					this.$router.push({ name: "erp_users" })
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "社員情報を更新しました。",
					})
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						})
					}
				})
		},
	},
}
</script>
